import { useState, useRef, useContext, useEffect } from 'react';
import styles from './Login.module.css'
import ReCAPTCHA from 'react-google-recaptcha';
import { Form, InputGroup, Button, Modal } from 'react-bootstrap'
import { FiUser, FiLock } from 'react-icons/fi'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { NavLink } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import logoFesaude2 from '../../assets/img/fesaude-logo2.png';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

function Login(props) {
  const [isNewPassword, setIsNewPassword] = useState(false);
  const [showNewPasswordModal, setShowNewPasswordModal] = useState(false);
  const [showEye, setShowEye] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showErrorModal, setShowErrorModal] = useState(false);
  const { authenticate, error, loading } = useContext(UserContext);

  const initialValues = {
    email: '',
    password: ''
  };

  const [values, setValues] = useState(initialValues);

  const captchaRef = useRef(null);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const handleRecaptcha = () => setRecaptchaToken(captchaRef.current.getValue());

  const handleErrorModalClose = () => setShowErrorModal(false);

  const setValue = (key, value) => {
    setValues({
      ...values,
      [key]: value
    });
  };

  const handleChange = e => setValue(
    e.target.getAttribute('name'),
    e.target.value
  );

  const handleEye = () => { 
    setShowEye(!showEye);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleNewPasswordModalClose = () => { 
    setShowNewPasswordModal(false);
  };

  useEffect(() => {
    setIsNewPassword(props?.location?.state?.isNewPassword);

    if (props?.location?.state?.isNewPassword) {
      setShowNewPasswordModal(true);
    }

    if (isNewPassword) {
      console.log(isNewPassword);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (error) {
      setShowModal(true);
    }
  }, [error]);

  const handleSubmit = async e => {
    e.preventDefault();

    try {
      const response = await authenticate({
        email: values.email,
        password: values.password,
        recaptchaToken
      });

      if (response?.error) {
        setErrorMessage(response?.error);
        setShowErrorModal(true);

        return;
      }
    } catch (err) {
      console.log(err);
    } finally {
      captchaRef?.current?.reset();
      setRecaptchaToken(null);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.form_container}>
        <div>
          <img src={logoFesaude2} alt="Logo FeSaúde" className={styles.logoImg} />
        </div>
        <h2 className={styles.title}>Login</h2>
        <Form 
          className={styles.form}
          as='form'
          onSubmit={handleSubmit} 
          noValidate
        >
          <Form.Group as='div' className={styles.form_group}>
          <Form.Label>*E-mail</Form.Label>
            <InputGroup>
              <InputGroup.Text className="border border-secondary">
              <FiUser />
              </InputGroup.Text>
              <Form.Control 
                type="email"
                required
                name="email"
                onChange={handleChange}
                value={values.email}
              />
            </InputGroup>
          </Form.Group>
          <Form.Group as='div' className={styles.form_group}>
            <Form.Label>*Senha</Form.Label>
            <InputGroup>
              <InputGroup.Text className="border border-secondary">
              <FiLock />
              </InputGroup.Text>
                  <Form.Control 
                    type={showEye ? 'text' : 'password'}
                    required
                    name="password"
                    onChange={handleChange}
                    value={values.password}
                  >
                  </Form.Control>
                  <InputGroup.Text>
                    {showEye ? (
                      <FaEyeSlash className={styles.eye} onClick={handleEye} />
                    ) : (
                      <FaEye className={styles.eye} onClick={handleEye} />
                    )}
                  </InputGroup.Text>
            </InputGroup>
            <NavLink to="/esqueci-senha" className={styles.link}>Esqueci a senha / Primeiro acesso</NavLink>
          </Form.Group>
          
          <div className={styles.captcha_container}>
            <ReCAPTCHA
              sitekey={RECAPTCHA_SITE_KEY}
              ref={captchaRef}
              onChange={handleRecaptcha}
              onExpired={() => setRecaptchaToken(null)}
            />
          </div>
            {!loading ? (
              <Button
                variant="flat"
                className={styles.btn}
                type="submit"
                disabled={!recaptchaToken ? true : false}
              >
                Entrar
              </Button>
            ) : (
              <Button 
               variant="flat" 
               className={styles.btn}
               disabled
              >
                Entrando...
              </Button>
            )}
        </Form>
        <Modal show={showModal} onHide={handleModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Erro</Modal.Title>
          </Modal.Header>
          <Modal.Body>{error}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleModalClose}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showNewPasswordModal} onHide={handleNewPasswordModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Sucesso</Modal.Title>
          </Modal.Header>
          <Modal.Body>Sua senha foi definida com sucesso!</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleNewPasswordModalClose}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showErrorModal} onHide={handleErrorModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Erro!</Modal.Title>
          </Modal.Header>
          <Modal.Body className={styles.modal_body}>{errorMessage}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleErrorModalClose}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  )
}

export default Login